export default "__VITE_ASSET__CyYHKU0C__"